var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5ZM11.1546 6.69003C11.2878 6.52181 11.2767 6.27673 11.1213 6.12132L11.0839 6.08802C10.9157 5.95481 10.6706 5.96591 10.5152 6.12132L7.18193 9.45462L5.6665 7.9396L5.62912 7.90629C5.46089 7.77308 5.21582 7.78418 5.06041 7.9396C4.89304 8.10696 4.89304 8.37832 5.06041 8.54569L6.87868 10.364L6.91606 10.3973C7.08428 10.5305 7.32936 10.5194 7.48477 10.364L11.1213 6.72741L11.1546 6.69003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickFilledIcon);
export default __webpack_public_path__ + "static/media/tick_filled_icon.94afae4989ff2fba7139556891a0ce4d.svg";
export { ForwardRef as ReactComponent };